import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle';
import FormButton from '../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../library/notifications/SarasTrans';
import InvTaxBreakupRow from './InvTaxBreakupRow';
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../library/layout/Index";

const InvTaxBreakup = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '580px' }}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Tax Calculation' />}
            formObject={formObject} >
            <div id="invTaxBreakup" >
                <div id="invrTaxBrupCommon" className="uiSearchHead" style={{ padding: "5px", marginTop: "5px", overflow: "auto" }}>
                    <input type="hidden" id="hcntid" paramName="cntId"  />
                    <div className="uiSHTBContent">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentTerms" }} value="Select Template" />
                        </span>

                        <FormInput formObject={formObject} rowKey="taxTemplRow" className="uiInput"
                            action={{ InputType: "ac", paramName: "taxTempl", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <FormButton formObject={formObject} rowKey="taxTemplRow" className="uiActionButton"
                            action={{ actionId: "refresh",  refreshMode:"self", actionParam: { calculate: "1" } }}
                            text={<SarasTrans value="Calculate" />}>
                        </FormButton>
                    </div>
                </div>

                <div id="invTaxBreakupDetail">
                    <UiView>
                        <UiViewHeading>
                            <UiTitle>
                                <span>
                                    <FormTitle formObject={formObject} value='Tax Breakup Details' />
                                </span>
                            </UiTitle>
                        </UiViewHeading>
                        <UiViewContent>
                            <ul className="uiListTable">
                                <li className="uiSearchHeading">
                                    <ul>
                                        <li className="uiColumnCenter uiColumn70"><SarasTrans value="Formula" /></li>
                                        <li className="uiColumnCenter uiColumn70"><SarasTrans value="Description" /></li>
                                        <li className="uiColumnCenter uiColumn70"><SarasTrans value="Base Amt" /></li>
                                        <li className="uiColumnCenter uiColumn70"><SarasTrans value="Tax Amt" /></li>
                                    </ul>
                                </li>
                                {
                                    Object.values(viewData).map((row, index) => (
                                        row.rowKey !== "taxTemplRow" ? (<InvTaxBreakupRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />) : ""
                                    ))
                                }
                            </ul>
                        </UiViewContent>
                    </UiView>
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(InvTaxBreakup, "taxbreakup", "itemDetail,invTrnFooter")